import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { LabService } from 'src/app/_service/lab.service';
declare var $: any;
@Component({
  selector: 'app-move-partner-leads',
  templateUrl: './move-partner-leads.component.html',
  styleUrls: ['./move-partner-leads.component.css']
})
export class MovePartnerLeadsComponent implements OnInit {
  moveLeadForm: FormGroup; loading: boolean = false; submitted: boolean = false; dataLoaded: boolean = false;
  lead_id: any; bds = []; bds_copy = [];

  constructor(private labapi: LabService, public dialogRef: MatDialogRef<MovePartnerLeadsComponent>, @Inject(MAT_DIALOG_DATA) public data: MatDialog,
    private sharedapi: SharedService, private leadapi: LeadsService, private formBuilder: FormBuilder) {

    if (data) {
      this.lead_id = data;
      this.getPartnerLeadDetails(this.lead_id);
    }
    this.moveLeadForm = this.formBuilder.group({
      'name': [null, Validators.required],
      'mobile': [null, Validators.required],
      'patient_age': [null],
      'gender': [null],
      'treatment_name': [null],
      'lead_status_name': [null],
      'city': [null, Validators.required],
      'circle': [null, Validators.required],
      'user_id': [null, Validators.required],
      'circle_id': [null, Validators.required],
      'city_id': [null, Validators.required],
      'treatment_id': [null, Validators.required],
      'description': [null],
      'lead_source': ['32']
    });
  }

  ngOnInit(): void {
    this.getbds();
  }

  get f() { return this.moveLeadForm.controls; }

  async submitLead() {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.moveLeadForm.invalid) {
      this.loading = false;
      return;
    }
    await this.labapi.addMoveLeadToLead(this.moveLeadForm.value)
      .subscribe((data: any) => {
        this.submitted = false;
        this.loading = false;
        if (data.status) {
          this.dialogRef.close();
          this.sharedapi.presentToast('Lead has been Added successfully.');
        } else {
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
  }

  async getPartnerLeadDetails(lead_id) {
    this.dataLoaded = false;
    await this.leadapi.getPartnerLeadDetails(this.lead_id).subscribe((response: any) => {
      this.dataLoaded = true;
      if (response.status) {
        this.moveLeadForm.patchValue({
          'name': response.data.name,
          'mobile': response.data.mobile,
          'patient_age': response.data.patient_age,
          'gender': response.data.gender,
          'treatment_name': response.data.treatment_name,
          'lead_status_name': response.data.lead_status_name,
          'city': response.data.city_name,
          'circle': response.data.circle_name,
          'city_id': response.data.city_id,
          'circle_id': response.data.circle_id,
          'treatment_id': response.data.circle_id,

        });
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
 
  async getbds(status=1)
  {
      this.leadapi.getbds(status).subscribe((data:any) => {
          if(data.status)
          {
              this.bds = data.data;
              this.bds_copy = this.bds;
          }else{
              this.bds = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  setSearchValue(type) {
    if (type == 'lead_owner') {
      $("#ownerSearch").val('');
      $("#ownerSearch").focus();
      this.bds = this.bds_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'lead_owner') {
      this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    }
  }

  CloseModal(): void {
    this.dialogRef.close();
  }
}
